import { useParams } from 'react-router-dom'
import TransactionDetailIndex from './index'
const TransactionDetail = () => {
  const { dynamic } = useParams()
  return <TransactionDetailIndex key={dynamic} />
}
export default TransactionDetail
